<template>
  <div>
    <v-row class="page-title-container">
      <v-col class="col-12">
        <h2 class="page-title">{{ lang.menuLinks.settings }}</h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col class="col-12">
        <v-card class="px-2 py-2 gc-box">
          <v-card-title class="font-weight-bold">{{
            lang.settings.myInfo
          }}</v-card-title>
          <v-card-text>
            <v-form>
              <v-row>
                <v-col
                  class="col-12 col-md-3 d-flex justify-center align-center"
                >
                  <div class="rel">
                    <v-img
                      v-if="myInfo.profileImageUrl"
                      :alt="myInfo.name + ' ' + myInfo.lastName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                      class="user-image"
                      aspect-ratio="1"
                      style="border-radius: 50%"
                      :src="myInfo.profileImageUrl"
                    ></v-img>
                    <v-img
                      class="user-image"
                      aspect-ratio="1"
                      :alt="'Avatar ' + myInfo.name + ' ' + myInfo.lastName"
                      :lazy-src="require('../assets/images/lazy-loading.png')"
                      style="border-radius: 50%"
                      v-else
                      :src="getUserProfileImage(myInfo.gender)"
                    ></v-img>
                    <div
                      class="input-image-container border-primary"
                      @click="triggerFileUpload()"
                    >
                      <div class="camera-container">
                        <v-icon>mdi-camera</v-icon>
                      </div>
                      <v-file-input
                        ref="fileInput"
                        style="display: none"
                        @change="onProfileImgUpload"
                        accept="image/*"
                        hide-input
                        show-size
                        prepend-icon="mdi-camera"
                        truncate-length="27"
                      ></v-file-input>
                    </div>
                  </div>
                </v-col>
                <v-col class="col-12 col-md-9 px-0">
                  <v-form ref="myInfoForm">
                    <v-row v-if="editMode">
                      <v-col class="col-12 pb-0 px-xs-0">
                        <v-text-field
                          v-model="myInfo.email"
                          :rules="[rules.required]"
                          disabled
                          :label="lang.fields.mail"
                        ></v-text-field>
                      </v-col>
                      <v-col class="col-12 col-md-6 pb-0 px-xs-0 pt-0">
                        <div class="input-group mb-3">
                          <label>{{ lang.fields.name }} *</label>
                          <input type="text" v-model="myInfo.name" />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-6 pb-0 px-xs-0 pt-0">
                        <div class="input-group mb-3">
                          <label>{{ lang.fields.surname }} *</label>
                          <input type="text" v-model="myInfo.lastName" />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4 custom-input px-xs-0 pt-0">
                          <div class="input-group">
                            <label>{{ lang.fields.birthDate + " *" }}</label>
                            <v-dialog
                              ref="dialogBirth"
                              v-model="modalBirth"
                              :return-value.sync="myInfo.dateOfBirth"
                              persistent
                              width="290px"
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                  v-model="myInfo.dateOfBirth"
                                  prepend-inner-icon="mdi-calendar"
                                  readonly
                                  hide-details
                                  outlined
                                  v-bind="attrs"
                                  dense
                                  v-on="on"
                                ></v-text-field>
                              </template>
                              <v-date-picker
                                v-model="myInfo.dateOfBirth"
                                scrollable
                              >
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="modalBirth = false"
                                >
                                  Cancel
                                </v-btn>
                                <v-btn
                                  text
                                  color="primary"
                                  @click="
                                    $refs.dialogBirth.save(myInfo.dateOfBirth)
                                  "
                                >
                                  OK
                                </v-btn>
                              </v-date-picker>
                            </v-dialog>
                          </div>
                        </v-col>
                      <v-col class="col-12 col-md-4 pb-0 px-xs-0 pt-0">
                        <div class="input-group mb-3 custom-input">
                          <div class="input-group">
                            <label>{{ lang.fields.country }} *</label>
                            <v-autocomplete
                              :items="countriesDropdown"
                              prepend-inner-icon="mdi-earth"
                              outlined
                              dense
                              hide-details
                              v-model="myInfo.country"
                            ></v-autocomplete>
                          </div>
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-4 pb-0 px-xs-0 pt-0">
                        <div class="input-group mb-3">
                          <label>{{ lang.fields.city }} *</label>
                          <input type="text" v-model="myInfo.city" />
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-4 pb-0 px-xs-0 pt-0">
                        <div class="input-group mb-3">
                          <label>{{ lang.fields.phone }}</label>
                          <input type="text" v-model="myInfo.phone" />
                        </div>
                        </v-col>
                        
                        <v-col class="col-12 col-md-4 py-0">
                          <v-radio-group
                            hide-details
                            v-model="myInfo.gender"
                            row
                            class="pt-4"
                          >
                            <v-radio
                              :label="lang.fields.other"
                              value="Other"
                              :ripple="false"
                            ></v-radio>
                            <v-radio
                              :label="lang.fields.male"
                              value="Male"
                              :ripple="false"
                            ></v-radio>
                            <v-radio
                              :label="lang.fields.female"
                              value="Female"
                              :ripple="false"
                            ></v-radio>
                          </v-radio-group>
                        </v-col>
                    </v-row>
                    <v-row v-else>
                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.mail }}</span>
                          <span class="value">{{ myInfo.email }}</span>
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-8 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.gender }}</span>
                          <span class="value">{{ myInfo.gender }}</span>
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.name }}</span>
                          <span class="value">{{ myInfo.name }}</span>
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.surname }}</span>
                          <span class="value">{{ myInfo.lastName }}</span>
                        </div>
                      </v-col>
                      
                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.birthDate }}</span>
                          <span class="value">{{ myInfo.dateOfBirth | shortDate }}</span>
                        </div>
                      </v-col>

                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.country }}</span>
                          <span class="value">{{ myInfo.country }}</span>
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.city }}</span>
                          <span class="value">{{ myInfo.city }}</span>
                        </div>
                      </v-col>
                      <v-col class="col-12 col-md-4 py-0 px-xs-0">
                        <div class="field">
                          <span class="label">{{ lang.fields.phone }}</span>
                          <span class="value">{{ myInfo.phone }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-col>
                <v-col class="col-12 d-flex justify-end pt-2 px-0">
                  <v-btn
                    v-if="editMode"
                    @click="cancelUserInfo()"
                    color="primary"
                    text
                    elevation="0"
                    >{{ lang.actions.cancel }}</v-btn
                  >
                  <v-btn
                    v-if="editMode"
                    @click="updateUserInfo()"
                    class="ml-2 btn-bg"
                    elevation="0"
                    >{{ lang.actions.save }}</v-btn
                  >
                  <v-btn
                    v-else
                    @click="setEditMode()"
                    class="ml-2 btn-bg"
                    elevation="0"
                    >{{ lang.actions.edit }}</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="col-12 col-md-4">
        <v-card class="gc-box px-2 py-2" style="height: 100%">
          <v-card-title class="font-weight-bold mb-6">{{
            lang.settings.changePassword
          }}</v-card-title>
          <v-card-text class="pb-0">
            <v-form ref="formChangePassword">
              <div class="input-group mb-3">
                <label>{{ lang.fields.currentPassword }} *</label>
                <input
                  type="password"
                  v-model="changePassword.currentPassword"
                />
              </div>
              <div class="input-group mb-3">
                <label>{{ lang.fields.newPassword }} *</label>
                <input type="password" v-model="changePassword.newPassword" />
              </div>
              <div class="input-group mb-3">
                <label>{{ lang.fields.confirmPassword }} *</label>
                <input
                  type="password"
                  v-model="changePassword.confirmPassword"
                />
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions class="d-flex justify-end mx-2 pb-4 pt-2">
            <v-btn
              class="btn-bg"
              @click="submitChangePassword()"
              elevation="0"
              block
              >{{ lang.actions.change }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col class="col-12 col-md-4">
        <v-card class="gc-box px-2 py-2" style="height: 100%">
          <v-card-title class="font-weight-bold">{{
            lang.settings.theme
          }}</v-card-title>
          <v-card-text>
            <v-radio-group v-model="userTheme" @change="updateUserTheme()">
              <div
                v-for="(theme, index) in themes"
                :key="index"
                class="d-flex mb-3"
              >
                <div
                  class="theme-color mr-2 mt-1"
                  :style="'background:' + theme.color + ';'"
                ></div>
                <v-radio
                  :color="theme.color"
                  :value="theme.value"
                  :label="theme.name"
                  :ripple="false"
                ></v-radio>
              </div>
            </v-radio-group>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col class="col-12 col-md-4">
        <v-card class="gc-box px-2 py-2" elevation="0" style="height: 100%">
          <v-card-title class="font-weight-bold">{{
            lang.settings.emailNotifications
          }}</v-card-title>
          <v-card-text>
            <v-checkbox
              :ripple="false"
              @change="updateNotificationSettings()"
              v-for="(notification, index) in emailNotifications"
              :key="index"
              v-model="emailNotificationsPicked"
              :label="notification.text"
              color="primary"
              :value="notification.value"
              hide-details
            ></v-checkbox>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import helpers from "../plugins/helpers.js";
import Compressor from "compressorjs";

export default {
  name: "Settings",
  data() {
    return {
      modalBirth: false,
      userTheme: "",
      myInfo: {},
      editMode: false,
      currentUserClone: null,
      emailNotificationsPicked: [],
      passwordRules: {
        passwordMatch: () =>
          this.changePassword.newPassword ===
            this.changePassword.confirmPassword ||
          this.lang.rules.passwordMustMatch,
      },
    };
  },
  computed: {
    ...mapGetters(["rules", "changePassword"]),
    ...mapGetters(["auth"]),
    ...mapGetters("user", ["currentUser"]),
    ...mapGetters("emailNotification", ["myEmailNotifications"]),
    lang() {
      return this.$store.state.langObj || {};
    },
    countriesDropdown() {
      return helpers.countries().map((el) => el.text);
    },
    emailNotifications() {
      return [
        {
          text: this.lang.emailNotifications.imageComments,
          value: "imageComment",
        },
        {
          text: this.lang.emailNotifications.videoComments,
          value: "videoComment",
        },
        {
          text: this.lang.emailNotifications.lastGreetings,
          value: "lastGreeting",
        },
        {
          text: this.lang.emailNotifications.followRequests,
          value: "followRequest",
        },
      ];
    },
    getTheme() {
      return this?.currentUser?.theme || "no-theme";
    },
    themes() {
      return [
        {
          name: this.lang.theme.default,
          color: "#3093a5",
          value: "theme-default",
        },
        {
          name: this.lang.theme.black,
          color: "#000000",
          value: "theme-black",
        },
        {
          name: this.lang.theme.blueGray,
          color: "#607D8B",
          value: "theme-blue-gray",
        },
        {
          name: this.lang.theme.blue,
          color: "#1E88E5",
          value: "theme-blue",
        },
        {
          name: this.lang.theme.cyan,
          color: "#00B8D4",
          value: "theme-cyan",
        },
        {
          name: this.lang.theme.darkRed,
          color: "#D50000",
          value: "theme-dark-red",
        },
        {
          name: this.lang.theme.green,
          color: "#00C853",
          value: "theme-green",
        },
        {
          name: this.lang.theme.lightGreen,
          color: "#64DD17",
          value: "theme-light-green",
        },
        {
          name: this.lang.theme.lightBrown,
          color: "#8D6E63",
          value: "theme-light-brown",
        },
        {
          name: this.lang.theme.limeDark,
          color: "#9E9D24",
          value: "theme-lime-dark",
        },
        {
          name: this.lang.theme.orange,
          color: "#F57C00",
          value: "theme-orange",
        },
        {
          name: this.lang.theme.pink,
          color: "#FF4081",
          value: "theme-pink",
        },
        {
          name: this.lang.theme.lightPurple,
          color: "#E040FB",
          value: "theme-light-purple",
        },
        {
          name: this.lang.theme.purple,
          color: "#800080",
          value: "theme-purple",
        },
      ];
    },
  },
  methods: {
    triggerFileUpload() {
      this.$refs.fileInput.$el.querySelector("input").click();
    },
    getUserProfileImage(gender) {
      return helpers.getAvatarProfile(gender, true);
    },
    onProfileImgUpload(file) {
      var notValid = file.size / (1024 * 1024) >= 10; // 10mb allowed per image
      if (notValid) {
        this.$store.commit("toast", {
          message: this.lang.general.maximumImageSize,
          color: "red lighten-2",
        });
        return;
      }
      new Compressor(file, {
        quality: 0.8,
        success: (compressedFile) => {
          var fd = new FormData();
          fd.append("file", compressedFile);
          fd.append("type", 2); // Example: 1 for Deceased, 2 for User

          this.$store.commit("loading", true);

          this.$store
            .dispatch("uploadUserProfileImage", fd)
            .then((response) => {
              this.myInfo.profileImageUrl = response.data;
              this.$store.commit("loading", false);
            });
        },
        error(err) {},
      });
    },
    submitChangePassword() {
      if (
        this.changePassword.currentPassword &&
        this.changePassword.newPassword &&
        this.changePassword.confirmPassword
      ) {
        if (
          this.changePassword.newPassword !==
          this.changePassword.confirmPassword
        ) {
          this.$store.commit("toast", {
            message: this.lang.general.passwordsDoNotMatch,
            color: "red lighten-2",
          });
        } else {
          var changePasswordPayload = { ...this.changePassword };
          changePasswordPayload.id = this.currentUser.id;
          this.$store
            .dispatch("user/changePassword", changePasswordPayload)
            .then(() => {
              this.$refs.formChangePassword.reset();
            });
        }
      } else {
        this.$store.commit("toast", {
          message: this.lang.general.fillAllFields,
          color: "red lighten-2",
        });
      }
    },
    updateUserTheme() {
      var payload = {
        id: this.currentUser.id,
        theme: this.userTheme,
      };
      this.$store.dispatch("user/updateUserTheme", payload).then(() => {
        var color = "#3093a5";

        switch (this.getTheme) {
          case "no-theme":
          case "theme-default":
            color = "#3093a5";
            break;
          case "theme-black":
            color = "#000000";
            break;
          case "theme-blue-gray":
            color = "#607D8B";
            break;
          case "theme-blue":
            color = "#1E88E5";
            break;
          case "theme-cyan":
            color = "#00B8D4";
            break;
          case "theme-dark-red":
            color = "#D50000";
            break;
          case "theme-green":
            color = "#64DD17";
            break;
          case "theme-light-green":
            color = "#00C853";
            break;
          case "theme-light-brown":
            color = "#8D6E63";
            break;
          case "theme-lime-dark":
            color = "#9E9D24";
            break;
          case "theme-orange":
            color = "#F57C00";
            break;
          case "theme-pink":
            color = "#FF4081";
            break;
          case "theme-light-purple":
            color = "#E040FB";
            break;
          case "theme-purple":
            color = "#800080";
            break;
        }

        document
          .querySelector('meta[name="theme-color"]')
          ?.setAttribute("content", color);
      });
    },
    updateNotificationSettings() {
      var payload = {
        id: this.currentUser.id,
        imageComment: this.emailNotificationsPicked.includes("imageComment"),
        videoComment: this.emailNotificationsPicked.includes("videoComment"),
        followRequest: this.emailNotificationsPicked.includes("followRequest"),
        lastGreeting: this.emailNotificationsPicked.includes("lastGreeting"),
      };
      this.$store.dispatch(
        "emailNotification/updateEmailNotifications",
        payload
      );
    },
    updateUserInfo() {
      if (this.$refs.myInfoForm.validate()) {
        if (
          !this.myInfo.name ||
          !this.myInfo.lastName ||
          !this.myInfo.country ||
          !this.myInfo.city||
          !this.myInfo.dateOfBirth
        ) {
          return this.$store.commit("toast", {
            message: this.lang.general.fillAllFields,
            color: "red lighten-2",
          });
        }
        this.$store.dispatch("user/updateUserInfo", this.myInfo).then(() => {
          this.editMode = false;
        });
      }
    },
    cancelUserInfo() {
      this.myInfo = { ...this.currentUserClone };
      this.editMode = false;
    },
    setEditMode() {
      this.currentUserClone = { ...this.$store.state.user.currentUser };
      this.editMode = true;
    },
  },
  mounted() {
    document.title = "Good Casper - Settings";
    this.myInfo = { ...this.currentUser };
    if (this.myInfo.notifications.followRequest) {
      this.emailNotificationsPicked.push("followRequest");
    }
    if (this.myInfo.notifications.imageComment) {
      this.emailNotificationsPicked.push("imageComment");
    }
    if (this.myInfo.notifications.lastGreeting) {
      this.emailNotificationsPicked.push("lastGreeting");
    }
    if (this.myInfo.notifications.videoComment) {
      this.emailNotificationsPicked.push("videoComment");
    }
    this.userTheme = this.myInfo.theme;
  },
};
</script>

<style lang="scss" scoped>
.field {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.label {
  font-size: 0.85rem;
  color: #7b7d8e;
  margin-bottom: 0px;
  // text-transform: uppercase;
  letter-spacing: 0.5px;
}

.value {
  font-size: 1rem;
  font-weight: 500;
  color: #1a1b1b;
  cursor: pointer;
  font-weight: 500;
  transition: color 0.2s ease;
}

.gc-box {
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05) !important;
}
.theme-color {
  width: 35px;
  height: 18px;
  border-radius: 2px;
}
.user-image {
  width: 180px;
}
.forgot-password-link {
  text-decoration: underline;
}
.rel {
  position: relative;
  width: 180px;
  .input-image-container {
    border-width: 5px;
    border-style: solid;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    display: flex;
    width: 180px;
    height: 180px;
    background: transparent;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    .camera-container {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: flex-start;
      padding-top: 6px;
      background-color: rgba(0, 0, 0, 0.5);
      width: 170px;
      height: 90px;
      position: absolute;
      bottom: -55px;
      border-bottom-left-radius: 90px; /* 50% of parent width */
      border-bottom-right-radius: 90px; /* 50% of parent width */
      * {
        color: #fff;
      }
    }
  }
  .v-input {
    flex: 0 0 100%;
    margin: 0;
    padding: 5px;
  }
}
@media only screen and (max-width: 770px) {
  .user-image {
    width: 160px;
  }
  .rel {
    width: 160px;
    .input-image-container {
      width: 160px;
      height: 160px;
    }
  }
}
@media only screen and (max-width: 770px) {
  .px-xs-0 {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  // .rel {
  //   position: relative;
  //   .input-image-container {
  //     position: absolute;
  //     top: 0;
  //     left: 70%;
  //   }
  // }
}
</style>
